import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.css';

const FancyButton = ({ className, children, type, ...rest }) => {
  const customClassName = classNames('fancy-button', className, `-${type}`);
  return (
    <a className={customClassName} {...rest}>
      {children}
    </a>
  );
};
FancyButton.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string,
};

FancyButton.defaultProps = {
  children: undefined,
  type: 'primary',
  className: undefined,
};

export default FancyButton;
